export default {
  'Energy-efficient buildings and industry': [
    'Recycling',
    'Other efficiency',
    'Industry EE', // Rename?
    'Industry energy efficiency',
    'Heat pumps',
    'Energy efficient retrofits',
    'Energy efficiency',
    'Efficient new builds',
    'Appliances',
    //'Other renewables',
  ],
  General: [
    'Other technologies/measures',
    'General',
    'General (No selection appropriate)', // TO BE REMOVED
    'Other renewables',
  ],
  'Low-carbon electricity': [
    'Utility-scale PV',
    'Residential/commercial PV',
    'Onshore wind',
    'Offshore wind',
    'Nuclear',
    'Low-carbon power',
    'Hydro',
    // 'Other renewables',
  ],
  'Energy access': ['Energy access', 'Electricity access', 'Clean cooking'],
  'Electricity networks': [
    'Transmission',
    'Grids',
    'Distribution',
    //'Charging infrastructure',
  ],
  'Fuels and technology innovation': [
    'Advanced biofuels',
    'Biogas',
    'Biofuels',
    'Other innovation',
    'Other Innovation', // TO BE REMOVED/lowercase
    'Hydrogen',
    'CCUS',
    'Batteries',
    'Methane abatement',
    'Critical minerals',
    'Thermal storage',
  ],
  color6: [],
  'Low-carbon and efficient transport': [
    'Efficient passenger cars',
    'Charging infrastructure',
    'Walkways and bikelanes',
    'Urban transit',
    'Trucks',
    'Ships',
    'Mass transit',
    'Low-carbon vehicles',
    'High-speed rail',
    'Electric passenger cars',
    'Electric 2- and 3-wheelers',
    'Busses',
    'Alternative fuel passenger cars',
    'Aircraft',
    // TO BE REMOVED
    'Aircraft (efficient/electric/alt fuel)',
    'Ships (efficient/electric/alt fuel)',
    'Trucks (efficient/electric/alt fuel)',
    'Busses (efficient/electric/alt fuel)',
  ],
  'People-centred transitions': [
    'Just transitions',
    /*
    'Energy poverty',
    'Just transitions',
    'Electricity access',
    'Energy poverty and affordability',
    */
  ],
  'Energy affordability': ['Energy affordability'],
  'Fossil fuels': ['Oil supply', 'Gas supply', 'Coal', 'Fuels'],
};
